import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { hasAnyScope, hasScope, normalizeScopeList } from '../permissions/scopePermissions';

export default function useScopePermissions() {
  const { user } = useAuth();
  const userScopes = useMemo(
    () => normalizeScopeList(user?.scopes),
    [user?.scopes]
  );

  return useMemo(() => ({
    userScopes,
    hasScope: (requiredScope) => hasScope(userScopes, requiredScope),
    hasAnyScope: (requiredScopes) => hasAnyScope(userScopes, requiredScopes),
  }), [userScopes]);
}
